// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"64":"68c1a3fe","161":"ccb32fb5","513":"32511757","613":"769563ea","641":"06faccc5","671":"0c3217a6","787":"3dab9326"}[chunkId] + ".chunk.js";
};